'use strict';

/**
 * Slugify a string
 * @param {string | null | undefined} str - The string to slugify
 * @returns {string} The slugified string
 */

var slugify = function slugify(str) {
  return (str !== null && str !== void 0 ? str : '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-');
};

exports.slugify = slugify;
//# sourceMappingURL=slugify.js.map
